import {
    DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent, EditRowDecorator, PanelProps, TableRow,
    TableRowCreationEvent, TableRowDisplayEvent, TableRowMode, Textbox
} from "@mcleod/components";
import { AutogenLayoutTableEquipmentIssued } from "./autogen/AutogenLayoutTableEquipmentIssued";
import { ModelRow } from "@mcleod/core";
import { LMEUserSettings } from "@mcleod/general";
import { EquipmentItem } from "./EquipmentGroupValidation";
import { EquipmentIssued } from "./EquipmentIssued";
import { CommonTooltips } from "@mcleod/common";

export class TableEquipmentIssued extends AutogenLayoutTableEquipmentIssued {
    private _parentRowType: EquipmentItem;

    override onLoad(): void {
        this.tableEquipmentIssued.addButtonCaption = "Add Equipment";
        this.tableEquipmentIssued.onEditLayoutLoaded = this._editEquipmentIssueLoaded();
    }

    private _editEquipmentIssueLoaded(): (rowDecorator: EditRowDecorator, tableRow: TableRow) => void {
        return (rowDecorator: EditRowDecorator, tableRow: TableRow) => {
            if (tableRow.mode == TableRowMode.QUICK_ADD) {
                rowDecorator.labelTitle.text = `Add Equipment Issued`;
            }

            rowDecorator.width = window.innerWidth * .45;

            const textbox: Textbox = (rowDecorator.layout as EquipmentIssued).textboxEquipmentTypeId;
            (rowDecorator.layout as EquipmentIssued).initialize(textbox, this._parentRowType, this.sourceEquipmentIssued);

            rowDecorator.multiButton.dropdownItems = null;
            if (rowDecorator.btnDelete) {       // Not visible during search
                rowDecorator.btnDelete.visible = false;
            }

            rowDecorator.onSave = (updatedData: ModelRow) => {
                tableRow.saveChangesFromEdit(updatedData);
            }
        }
    }

    public setParentRowType(value: EquipmentItem) {
        this._parentRowType = value;
    }

    tableEquipmentIssuedOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxEquipmentId = tableRow.findComponentById("textboxEquipmentTypeId") as Textbox;
        const textboxLocation = tableRow.findComponentById("textboxLocationId") as Textbox;

        this.setEquipmentTypeModel(textboxEquipmentId, this._parentRowType);

        if (tableRow.mode == TableRowMode.QUICK_ADD) {
            // Set a default of issued on teh quick add row.
            const textboxStatus = tableRow.findComponentById("textboxStatus") as Textbox;
            const row2 = textboxStatus.getRelevantModelRow();
            row2.setValues({
                "status": "I"
            });

            // Clear the location field on the quick add row.
            const locationRow = textboxLocation.getRelevantModelRow();
            locationRow.setValues({
                "id": "",
                "name": "",
            });
        } else {
            if (tableRow.data.get("location_id") != null) {
                if (tableRow.data != null) {
                    const modelRow = tableRow.data;
                    CommonTooltips.setTooltipContentLayout(
                        textboxLocation, null, "lme/dispatch/LocationQuickInfo", null,
                        {"id":modelRow.get("location_id")}
                    );
                }
            }
        }
    }

    setEquipmentTypeModel(textbox: Textbox, type: EquipmentItem) {

        let lookupModel;
        let lookupModelLayout;
        switch(type) {
            case EquipmentItem.TRACTOR: {
                lookupModel = "lme/dispatch/match-tractor-item-type";
                lookupModelLayout = "lme/dispatch/EquipmentTypeAppliesToTractorItem";
                break;
            }
            case EquipmentItem.TRAILER: {
                lookupModel = "lme/dispatch/match-trailer-item-type";
                lookupModelLayout = "lme/dispatch/EquipmentTypeAppliesToTrailerItem";
                break;
            }
            case EquipmentItem.DRIVER: {
                lookupModel = "lme/dispatch/match-driver-item-type";
                lookupModelLayout = "lme/dispatch/EquipmentTypeAppliesToDriverItem";
                break;
            }
            default: {
                lookupModel = "";
                lookupModelLayout = "";
                break;
            }
        }
        textbox.lookupModel = lookupModel;
        textbox.lookupModelLayout = lookupModelLayout;
    }

    /** This is an event handler for the beforeExecution event of sourceEquipmentIssued. */
    sourceEquipmentIssuedBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.parent_row_id = this.mainDataSource.parentDataSource.activeRow.get("id");
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxIssuedUserId. */
    textboxIssuedUserIdBeforeLookupModelSearch(event) {
        event.filter.is_active = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxReceivedUserId. */
    textboxReceivedUserIdBeforeLookupModelSearch(event) {
        event.filter.is_active = "Y";
    }

    /** This is an event handler for the onRowCreate event of tableEquipmentIssued. */
    tableEquipmentIssuedOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        if (tableRow.mode == TableRowMode.QUICK_ADD) {
            modelRow.setValueAndLookupModelData("issued_user_id", LMEUserSettings.getUserId(), LMEUserSettings.getUserLookupModelData());
        } else if (modelRow.isNull("location_id")) {
            modelRow.removeLookupModelData("location_id");
        }
    }

}
